import { PropsWithChildren } from "react";
import { ContentWrapperStyles } from "./ContentWrapper.styles";
import { ContentWrapperProps } from "./ContentWrapper.props";
import { useBannerState } from "../../../hooks";

export const ContentWrapper = ({
  children,
  autoWidth,
  customSideMargin
}: PropsWithChildren<ContentWrapperProps>) => {
  const { bannerHeight } = useBannerState();

  return (
    <ContentWrapperStyles
      topOffset={bannerHeight}
      autoWidth={autoWidth}
      customSideMargin={customSideMargin}
    >
      {children}
    </ContentWrapperStyles>
  );
};
